import { SupportTicketCloseReasonEnum } from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function supportTicketCloseReasonNameFilter(reason: SupportTicketCloseReasonEnum): string {
  switch (reason) {
    case SupportTicketCloseReasonEnum.ResolvedByEmployee: return i18n.t(LF.SupportCloseResolvedByEmployee) as string;
    case SupportTicketCloseReasonEnum.ResolvedByDriver: return i18n.t(LF.SupportCloseResolvedByDriver) as string;
    case SupportTicketCloseReasonEnum.InvalidRequest: return i18n.t(LF.SupportCloseInvalidRequest) as string;
    case SupportTicketCloseReasonEnum.Duplicate: return i18n.t(LF.SupportCloseDuplicate) as string;
    case SupportTicketCloseReasonEnum.NoResponse: return i18n.t(LF.SupportCloseNoResponse) as string;
    default: return '';
  }
}
